import Button from '@atlaskit/button';
import {
  useAnalytics,
  SendDatabaseSortEventSources,
  sendSortEvent
} from '@databases/analytics';
import { type DatabaseField } from '@databases/types/database';
import { type DatabaseViewSettings } from '@databases/types/database/view';
// FIXME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import { getSortIcon } from '@databases/view-settings/utils';
import React, { type FunctionComponent, useMemo, useCallback } from 'react';

export interface SortingActionProps {
  ascending?: boolean;
  customOrder?: boolean;
  field: DatabaseField;
  onChange: (value: DatabaseViewSettings['sorts'][number]) => void;
  contentId: string;
}

const SortingAction: FunctionComponent<SortingActionProps> = ({
  ascending,
  customOrder,
  field,
  contentId,
  onChange
}) => {
  const client = useAnalytics();

  const handleChange = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      const sortSettings = {
        fieldId: field.id,
        ascending: !ascending,
        customOrder
      };
      onChange(sortSettings);
      sendSortEvent(
        client,
        sortSettings,
        SendDatabaseSortEventSources.FIELD_NAME,
        field.type,
        contentId
      );
    },
    [field.id, field.type, ascending, customOrder, onChange, client, contentId]
  );

  const icon = useMemo(() => getSortIcon(!!ascending), [ascending]);

  return (
    <Button
      spacing="compact"
      onClick={handleChange}
      iconBefore={icon}
      appearance="subtle"
    />
  );
};

export default SortingAction;
